/* global angular */

angular.module('AemTransparentAccount')
  .factory('transparentAccountService', transparentAccountService)

transparentAccountService.$inject = ['$http', 'apiBase', 'CacheFactory']

function transparentAccountService ($http, apiBase, CacheFactory) {
  var endpointPath = apiBase + 'v3/transparentAccounts'
  CacheFactory('allTransparentAccounts', {
    // 30mins
    maxAge: 30 * 60 * 1000,
    storageMode: 'sessionStorage',
    deleteOnExpire: 'passive'
  })

  function endpoint (endPath) {
    if (endPath) {
      return endpointPath + '/' + endPath
    } else {
      return endpointPath
    }
  }

  function accountDetail (id) {
    return $http({
      url: endpoint(id),
      method: 'GET'
    })
  }

  function accountTransaction (id, params) {
    return $http({
      url: endpoint(id + '/transactions'),
      method: 'GET',
      params: params
    })
  }

  function getAllAccounts () {
    return $http({
      url: endpoint(),
      method: 'GET',
      cache: CacheFactory.get('allTransparentAccounts'),
      params: {
        size: 100000 // magic const, otherwise gets 50 per page
      }
    })
  }

  return {
    accountDetail: accountDetail,
    accountTransaction: accountTransaction,
    getAllAccounts: getAllAccounts
  }
}
